const currencyData = [
  {
    standard_name: "USD",
    short_name: "dollar",
    symbol: "$",
    full_name: "Dollar ($)",
    countries: ["united states", "usa"],
  },
  {
    standard_name: "GBP",
    short_name: "pound",
    symbol: "£",
    full_name: "Pound (£)",
    countries: ["united kingdom", "uk"],
  },
  {
    standard_name: "EUR",
    short_name: "euro",
    symbol: "€",
    full_name: "Euro (€)",
    countries: ["netherlands", "ireland", "spain", "germany", "italy", "france", "portugal"],
  },
  {
    standard_name: "CNY",
    short_name: "cny",
    symbol: "¥",
    full_name: "Chinese Yuan (¥)",
    countries: ["china"],
  },
  {
    standard_name: "CAD",
    short_name: "cad",
    symbol: "CA$",
    full_name: "Canadian Dollar (Ca$)",
    countries: ["canada"],
  },
  {
    standard_name: "INR",
    short_name: "inr",
    symbol: "₹",
    full_name: "Indian Rupee (₹)",
    countries: ["india"],
  },
  {
    standard_name: "AUD",
    short_name: "aud",
    symbol: "AU$",
    full_name: "Australian Dollar (Au$)",
    countries: ["australia"],
  },
  {
    standard_name: "AED",
    short_name: "aed",
    symbol: "AED",
    full_name: "UAE Dirham (AED)",
    countries: ["united arab emirates"],
  },
  {
    standard_name: "SGD",
    short_name: "sgd",
    symbol: "S$",
    full_name: "Singapore Dollar (S$)",
    countries: ["singapore"],
  },
  {
    standard_name: "NZD",
    short_name: "nzd",
    symbol: "NZ$",
    full_name: "New Zealand Dollar (NZ$)",
    countries: ["new zealand"],
  },
  {
    standard_name: "KRW",
    short_name: "krw",
    symbol: "₩",
    full_name: "Korean Won (₩)",
    countries: ["south korea"],
  },
  {
    standard_name: "DKK",
    short_name: "dkk",
    symbol: "DKK",
    full_name: "Danish Krone (DKK)",
    countries: ["denmark"],
  },
  {
    standard_name: "HKD",
    short_name: "hkd",
    symbol: "HK$",
    full_name: "Hong Kong Dollar (HK$)",
    countries: ["hong kong"],
  },
  {
    standard_name: "TWD",
    short_name: "twd",
    symbol: "NT$",
    full_name: "New Taiwan Dollar (NT$)",
    countries: ["taiwan"],
  },
];

const ALLOWED_CURRENCY_CODES = [
  "USD",
  "GBP",
  "EUR",
  "CNY",
  "CAD",
  "INR",
  "AUD",
  "AED",
  "SGD",
  "NZD",
  "KRW",
  "DKK",
  "HKD",
  "TWD",
];

export default currencyData;
export { ALLOWED_CURRENCY_CODES };
